import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = {
  key: 0,
  class: "page-item"
}
const _hoisted_3 = { class: "page-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", { class: "page-item px-3" }, "...", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", { class: "page-item px-3" }, "...", -1)
const _hoisted_6 = { class: "page-item" }
const _hoisted_7 = {
  key: 3,
  class: "page-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Arrow = _resolveComponent("Arrow")!
  const _component_Clickable = _resolveComponent("Clickable")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_ctx.current > 1)
      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createVNode(_component_Clickable, {
            class: "page-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo(_ctx.current - 1)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Arrow, {
                dir: "left",
                sm: ""
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.start !== 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_Clickable, {
              class: "page-link",
              title: "First",
              "aria-label": "First",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo(1)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("1")
              ]),
              _: 1
            })
          ]),
          _hoisted_4
        ], 64))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagesToDisplay, (index) => {
      return (_openBlock(), _createElementBlock("li", {
        class: _normalizeClass(["page-item", [index === _ctx.current && 'active']]),
        key: index
      }, [
        _createVNode(_component_Clickable, {
          class: "page-link",
          onClick: ($event: any) => (_ctx.goTo(index))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(index), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ], 2))
    }), 128)),
    (_ctx.current < _ctx.total - _ctx.trimTo + 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_5,
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_Clickable, {
              class: "page-link",
              title: "Last",
              "aria-label": "Last",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo(_ctx.total)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.total), 1)
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.current < _ctx.total)
      ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
          _createVNode(_component_Clickable, {
            class: "page-link",
            title: "Next",
            "aria-label": "Next",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo(_ctx.current + 1)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Arrow, { sm: "" })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}